var map = {
	"./account.svg": "ecec",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./edit.svg": "daf0",
	"./envelope-check.svg": "ef85",
	"./expand.svg": "8336",
	"./location.svg": "d2eb",
	"./microphone.svg": "4eb8",
	"./move.svg": "d8c1",
	"./shrink.svg": "3a88",
	"./tool.svg": "b323",
	"./trash.svg": "af22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";